<template lang="pug">
.briq-form-element
  label {{ label }}
  briq-required-and-optional-markers(:isRequired="this.$attrs.required" :isDisabled="this.$attrs.disabled || this.$attrs.readonly" :hideOptionalMarker="hideOptionalMarker" :label="label")
  briq-tooltip(:help="help")
  div.input-holder
    input.input.type-standard(
      v-model="innerValue"
      v-bind="$attrs"
      :style="inlineStyle"
      class="input"
      readonly="true"
      @click="openColorDialog()"
      :required="false"
      )
    v-input-colorpicker.color-picker(:id="`${name}-color-picker`" ref="colorPicker" v-model="innerValue")
  .validation-message(v-if="error") {{ error }}
</template>

<script>
import InputColorPicker from 'vue-native-color-picker'

export default {
  name: 'BriqColorInput',
  components: {
    'v-input-colorpicker': InputColorPicker,
  },
  props: {
    label: String,
    name: {
      type: String,
      required: true,
    },
    hideOptionalMarker: {
      type: Boolean,
      default: false,
    },
    help: String,
    error: String,
    value: String,
  },
  inheritAttrs: false,
  data() {
    return {
      innerValue: null,
    }
  },
  computed: {
    inputBackgroundColor() {
      return this.innerValue !== '' ? this.innerValue : '#fff'
    },
    inlineStyle() {
      return this.$attrs.disabled
        ? 'background-color: #eee; color: #2c333a'
        : `background-color: ${this.inputBackgroundColor}; color: ${this.idealTextColor(
            this.innerValue,
          )}`
    },
  },
  methods: {
    openColorDialog() {
      this.$refs.colorPicker.$el.click()
    },
    idealTextColor(bgColor) {
      // The idea for this method is get from here https://stackoverflow.com/a/4726403/2911117
      if (!bgColor) return null
      const components = this.getRGBComponents(bgColor)
      const bgDelta = components.R * 0.299 + components.G * 0.587 + components.B * 0.114
      return 255 - bgDelta < 105 ? '#000000' : '#ffffff'
    },
    getRGBComponents(color) {
      if (!color) return null
      const r = color.substring(1, 3)
      const g = color.substring(3, 5)
      const b = color.substring(5, 7)
      return {
        R: parseInt(r, 16),
        G: parseInt(g, 16),
        B: parseInt(b, 16),
      }
    },
  },
  beforeMount() {
    this.innerValue = this.value
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal
    },
    innerValue(newVal) {
      this.$emit('input', this.innerValue)
    },
  },
}
</script>

<style scoped lang="stylus">
label.inputLabel
  padding: 15px

.input-holder
  position relative

input.input
  position relative
  width 100%
  border solid 1px #ebebeb
  border-radius 3px
  background white
  color #2c333a
  padding 7px

  &[disabled]
    background #eee
    color #2c333a

  &[disabled]
    cursor not-allowed

  &::placeholder
    color fade(@color-text, 40%)

  &:hover
    border-color #D3D3D3

  &:focus, &:active
    outline 0
    border-color #009BFF
    box-shadow 0 2px 4px 0 rgba(0, 0, 0, .15)

.color-picker
  position absolute
  top 10px
  left 0
  visibility hidden
</style>
